import axios from "axios";

const state = {
  shoppings: [],
  loading: false,
  meta: {},
};

const getters = {
  shoppings: (state) => state.shoppings,
  loading: (state) => state.loading,
  meta: (state) => state.meta,
};

const actions = {
  getShoppings({ commit }, params = {}) {
    commit("setLoading", true);
    return axios
      .get(`${process.env.VUE_APP_BACKEND_ROUTE}api/v2/shoppings`, {
        params,
      })
      .then((response) => {
        commit("setShoppings", response.data.data);
        commit("setMeta", response.data.meta);
      })
      .finally(() => {
        commit("setLoading", false);
      });
  },

  getShoppingsByProvider({ commit }, params) {
    return new Promise((resolve, reject) => {
      commit("setLoading", true);
      axios.get(`${process.env.VUE_APP_BACKEND_ROUTE}api/v2/shoppings`, { params }).then(response=>{
        commit('setShoppings', response.data.data);
        commit("setMeta", response.data.meta);
        commit("setLoading", false);
        resolve(true)
      })
    })
  },

  createShopping({ commit }, payload) {
    commit("setLoading", true);
    return axios
      .post(`${process.env.VUE_APP_BACKEND_ROUTE}api/v2/shoppings`, payload)
      .finally(() => {
        commit("setLoading", false);
      });
  },

  updateShopping({ commit }, payload) {
    commit("setLoading", true);
    return axios
      .put(
        `${process.env.VUE_APP_BACKEND_ROUTE}api/v2/shoppings/${payload.id}`,
        payload
      )
      .finally(() => {
        commit("setLoading", false);
      });
  },

  deleteShopping({ commit }, id) {
    commit("setLoading", true);
    return axios
      .delete(`${process.env.VUE_APP_BACKEND_ROUTE}api/v2/shoppings/${id}`)
      .finally(() => {
        commit("setLoading", false);
      });
  },
};

const mutations = {
  setShoppings(state, data) {
    state.shoppings = data;
  },
  setMeta(state, meta) {
    state.meta = meta;
  },
  setLoading(state, value) {
    state.loading = value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
